export default __webpack_public_path__ + "static/mlp-ba5bf3f3dc3303452c5ad411cc9f24bc.png";